<template>
  <div id="app">
    <router-view v-wechat-title="$route.meta.title" :key="keyRouterKey"/>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
import { getUserToken } from '@/utils/cookies'
import utils from '@/utils/utils'
export default {
  name: 'App',
  watch:{
    "$route"(){
      // console.log(this.$route)
      this.goTop()
    }
  },
  computed: {
    keyRouterKey(){
      return new Date().getTime()+this.$route.path
    },
    ...mapGetters([
      'userInfo'
      ])
  },
  methods:{
    goTop(){
      document.body.scrollTop = 0,
      document.documentElement.scrollTop = 0
    },
    checkIE(){
      // console.log(utils.IEVersion())
      // console.log(navigator.userAgent)
      // console.log(window.navigator)
      if(utils.IEVersion()!==-1){
        if(window.sessionStorage.getItem('edge')){return;}
        this.$alert('为了您更好的体验本网站全部功能，建议您不要使用IE浏览器，请您使用Chorm、火狐、360等浏览器。',  {
          confirmButtonText: '确定',
          callback: action => {
           window.sessionStorage.setItem('edge','edge')
          }
        });
      }else{
        window.sessionStorage.removeItem('edge')
      }
    }
  },
  created ()  {
    this.checkIE()
    
  },
}
</script>

<style>
#app{
  min-width: 1200px;
}
.el-pagination__jump{
  cursor: pointer;
}
p{
  width: auto;
}
.cwy_new_see_box{
      width: 1200px;
    height: 28px;
    border-radius: 14px;
    /* border: solid 1px #f30000; */
    /* margin: 30px auto 0; */
    cursor: pointer;
}
.design_see{
  width: 120px;
  border-radius: 14px;
      font-size: 14px;
    color: #f30000;
    line-height: 28px;
    text-align: center;
    margin: 0 auto;
    border: solid 1px #f30000;
}
</style>



// WEBPACK FOOTER //
// src/App.vue